export const ICON_PROPERTY_NAME: string = 'icon';
export const NAME_PROPERTY_NAME: string = 'name';

export const PROVIDER_ROOT_FOLDER_BREADCRUMB_ID: string = 'root';
